export default __webpack_public_path__ + "static/youtube_1-bed134f9ac684ae4278ff55fa7dc9446.jpg";